import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const ManifestGuestsTable = ({ guests }) => {
    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Guest</TableCell>
                            <TableCell>Reservation ID</TableCell>
                            <TableCell>Booking Date</TableCell>
                            <TableCell>Ticket name</TableCell>
                            <TableCell>Ticket quantity</TableCell>
                            <TableCell>Custom fields</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {guests?.map(guest =>
                            guest.tickets.map((ticket, ticketIdx) => (
                                <TableRow key={`${guest.reservationId}-${ticket.name}`}>
                                    {ticketIdx === 0 ? (
                                        <>
                                            <TableCell rowSpan={guest.tickets.length}>
                                                {guest.guestName}
                                                <br />
                                                <small>
                                                    {guest.guestEmail || ''}
                                                    <br />
                                                    {guest.guestPhone || ''}
                                                </small>
                                            </TableCell>
                                            <TableCell rowSpan={guest.tickets.length}>
                                                {guest.reservationId}
                                            </TableCell>
                                            <TableCell rowSpan={guest.tickets.length}>
                                                {guest.bookingDate
                                                    ? moment(guest.bookingDate).format(
                                                          'ddd, MMM DD, YYYY'
                                                      )
                                                    : ''}
                                            </TableCell>
                                        </>
                                    ) : null}
                                    <TableCell>{ticket.name}</TableCell>
                                    <TableCell>{ticket.quantity}</TableCell>
                                    <TableCell>
                                        {Object.keys(ticket.customFields || {}).length > 0 ? (
                                            Object.entries(ticket.customFields).map(
                                                ([key, value]) => (
                                                    <p key={key} style={{ margin: 0 }}>
                                                        {key}:{' '}
                                                        {typeof value === 'boolean'
                                                            ? value === true
                                                                ? 'true'
                                                                : 'false'
                                                            : typeof value === 'object' &&
                                                              value !== null
                                                            ? JSON.stringify(value)
                                                            : value}
                                                    </p>
                                                )
                                            )
                                        ) : (
                                            <p style={{ margin: 0 }}>-</p>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default ManifestGuestsTable;
